import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import ProtectedPermissionRoute from "components/util-components/ProtectedPermissionRendering";
import { MODULES } from "constants/ModulesConstant";
import { PERMISSIONS } from "constants/PermissionConstant";
export const AppViews = () => {
  return (
    // <Suspense fallback={<Loading cover="content" />}>
    <Suspense fallback={<></>}>
      <Switch>
        <Route
          path={`${APP_PREFIX_PATH}/dashboard`}
          component={lazy(() => import(`./dashboard/`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/profile`}
          component={lazy(() => import(`./profile`))}
        />

        {/* <Route
          path={`${APP_PREFIX_PATH}/chatbot/disliked-answers/list`}
          component={lazy(() => import(`./chatbot/disliked-answers/list`))}
        /> */}
        <Route
          path={`${APP_PREFIX_PATH}/chatbot/conversations/list`}
          component={lazy(() => import(`./chatbot/conversations/list`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/chatbot/faqs/list`}
          component={lazy(() => import(`./chatbot/faqs/list`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/chatbot/top-users/list`}
          component={lazy(() => import(`./chatbot/top-users/list`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/chatbot/analytics/list`}
          component={lazy(() => import(`./chatbot/analytics/list`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/chatbot/popular-topics/list`}
          component={lazy(() => import(`./chatbot/popular-topics/list`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/chatbot/response-time/list`}
          component={lazy(() => import(`./chatbot/response-time/list`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/chatbot/satisfaction/list`}
          component={lazy(() => import(`./chatbot/satisfaction/list`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/chatbot/peak-usage/list`}
          component={lazy(() => import(`./chatbot/peak-usage/list`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/chatbot/liked-messages/list`}
          component={lazy(() => import(`./chatbot/liked-messages/list`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/chatbot/disliked-messages/list`}
          component={lazy(() => import(`./chatbot/disliked-messages/list`))}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/news/list`}
          component={lazy(() => import(`./news/list-news`))}
          moduleKey={MODULES.NEWS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/news/add`}
          component={lazy(() => import(`./news/add-news`))}
          moduleKey={MODULES.NEWS}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/news/:id`}
          component={lazy(() => import(`./news/update-news`))}
          moduleKey={MODULES.NEWS}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publication-news/list`}
          component={lazy(() => import(`./publication-news/list`))}
          moduleKey={MODULES.PUBLICATION_NEWS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publication-news/add`}
          component={lazy(() => import(`./publication-news/add`))}
          moduleKey={MODULES.PUBLICATION_NEWS}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publication-news/:id`}
          component={lazy(() => import(`./publication-news/update`))}
          moduleKey={MODULES.PUBLICATION_NEWS}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/news-category/list`}
          component={lazy(() => import(`./news-categories`))}
          moduleKey={MODULES.NEWS_CATEGORIES}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/news-category/add`}
          component={lazy(() => import(`./news-categories/add-news-category`))}
          moduleKey={MODULES.NEWS_CATEGORIES}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/news-category/:id`}
          component={lazy(() =>
            import(`./news-categories/update-news-category`)
          )}
          moduleKey={MODULES.NEWS_CATEGORIES}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/journals/news/list`}
          component={lazy(() => import(`./journals-news/list-news`))}
          moduleKey={MODULES.JOURNALISM}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/journals/news/add`}
          component={lazy(() => import(`./journals-news/add-news`))}
          moduleKey={MODULES.JOURNALISM}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/journals/news/:id`}
          component={lazy(() => import(`./journals-news/update-news`))}
          moduleKey={MODULES.JOURNALISM}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/journals/list`}
          component={lazy(() => import(`./journals-categories`))}
          moduleKey={MODULES.JOURNAL_CATEGORY}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/journals/add`}
          component={lazy(() =>
            import(`./journals-categories/add-journal-category/`)
          )}
          moduleKey={MODULES.JOURNAL_CATEGORY}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/journals/:id`}
          component={lazy(() =>
            import(`./journals-categories/update-journal-category`)
          )}
          moduleKey={MODULES.JOURNAL_CATEGORY}
          permissionId={PERMISSIONS.EDIT}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/related-websites/add`}
          component={lazy(() => import(`./related-websites/add`))}
          moduleKey={MODULES.RELATED_WEBSITE}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/related-websites-type/list`}
          component={lazy(() => import(`./related-websites-type/list`))}
          moduleKey={MODULES.RELATED_WEBSITE}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/related-websites-type/add`}
          component={lazy(() => import(`./related-websites-type/add`))}
          moduleKey={MODULES.RELATED_WEBSITE}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/related-websites-type/:id`}
          component={lazy(() => import(`./related-websites-type/update`))}
          moduleKey={MODULES.RELATED_WEBSITE}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/related-websites/list`}
          component={lazy(() => import(`./related-websites`))}
          moduleKey={MODULES.RELATED_WEBSITE}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/related-websites/:id`}
          component={lazy(() => import(`./related-websites/update`))}
          moduleKey={MODULES.RELATED_WEBSITE}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/tags/list`}
          component={lazy(() => import(`./tags/list`))}
          moduleKey={MODULES.TAGS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/tags/add`}
          component={lazy(() => import(`./tags/add`))}
          moduleKey={MODULES.TAGS}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/tags/:id`}
          component={lazy(() => import(`./tags/update`))}
          moduleKey={MODULES.TAGS}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/photo-media-category/list`}
          component={lazy(() =>
            import(`./photo-library/photo-media-category/list`)
          )}
          moduleKey={MODULES.PHOTO_CATEGORY}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/photo-media-category/add`}
          component={lazy(() =>
            import(`./photo-library/photo-media-category/add`)
          )}
          moduleKey={MODULES.PHOTO_CATEGORY}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/photo-media-category/:id`}
          component={lazy(() =>
            import(`./photo-library/photo-media-category/update`)
          )}
          moduleKey={MODULES.PHOTO_CATEGORY}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/photo-media/list`}
          component={lazy(() => import(`./photo-library/photo-media/list`))}
          moduleKey={MODULES.PHOTO}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/photo-media/add`}
          component={lazy(() => import(`./photo-library/photo-media/add`))}
          moduleKey={MODULES.PHOTO}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/photo-media/:id`}
          component={lazy(() => import(`./photo-library/photo-media/update`))}
          moduleKey={MODULES.PHOTO}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/photo-album/:id`}
          component={lazy(() =>
            import(`./photo-library/photo-album/photo-album`)
          )}
          moduleKey={MODULES.PHOTO_ALBUM}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/regional-office/list`}
          component={lazy(() => import(`./regional-office/list`))}
          moduleKey={MODULES.REGIONAL_OFFICE}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/regional-office/add`}
          component={lazy(() => import(`./regional-office/add`))}
          moduleKey={MODULES.REGIONAL_OFFICE}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/regional-office/:id`}
          component={lazy(() => import(`./regional-office/update`))}
          moduleKey={MODULES.REGIONAL_OFFICE}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/additional-office/list`}
          component={lazy(() => import(`./additional-office/list`))}
          moduleKey={MODULES.REGIONAL_OFFICE}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/additional-office/update/:id`}
          component={lazy(() => import(`./additional-office/update`))}
          moduleKey={MODULES.REGIONAL_OFFICE}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/video-library-category/list`}
          component={lazy(() => import(`./video-library-category/list`))}
          moduleKey={MODULES.VIDEO_LIBRARY_CATEGORY}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/video-library-category/add`}
          component={lazy(() => import(`./video-library-category/add`))}
          moduleKey={MODULES.VIDEO_LIBRARY_CATEGORY}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/video-library-category/:id`}
          component={lazy(() => import(`./video-library-category/update`))}
          moduleKey={MODULES.VIDEO_LIBRARY_CATEGORY}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/video-library/list`}
          component={lazy(() => import(`./video-library/list`))}
          moduleKey={MODULES.VIDEO_LIBRARY}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/video-library/add`}
          component={lazy(() => import(`./video-library/add`))}
          moduleKey={MODULES.VIDEO_LIBRARY}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/video-library/:id`}
          component={lazy(() => import(`./video-library/update`))}
          moduleKey={MODULES.VIDEO_LIBRARY}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/radio-category/list`}
          component={lazy(() => import(`./radio-category/list`))}
          moduleKey={MODULES.RADIO_LIBRARY_CATEGORY}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/radio-category/add`}
          component={lazy(() => import(`./radio-category/add`))}
          moduleKey={MODULES.RADIO_LIBRARY_CATEGORY}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/radio-category/:id`}
          component={lazy(() => import(`./radio-category/update`))}
          moduleKey={MODULES.RADIO_LIBRARY_CATEGORY}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/radio/list`}
          component={lazy(() => import(`./radio/list`))}
          moduleKey={MODULES.RADIO_LIBRARY}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/radio/add`}
          component={lazy(() => import(`./radio/add`))}
          moduleKey={MODULES.RADIO_LIBRARY}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/radio/:id`}
          component={lazy(() => import(`./radio/update`))}
          moduleKey={MODULES.RADIO_LIBRARY}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/event-type/list`}
          component={lazy(() => import(`./events/event-type/list`))}
          moduleKey={MODULES.EVENT_TYPES}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/event-type/add`}
          component={lazy(() => import(`./events/event-type/add`))}
          moduleKey={MODULES.EVENT_TYPES}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/event-type/:id`}
          component={lazy(() => import(`./events/event-type/update`))}
          moduleKey={MODULES.EVENT_TYPES}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/event/list`}
          component={lazy(() => import(`./events/event/list`))}
          moduleKey={MODULES.CALENDARS} // EVENTS MISSED
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/event/add`}
          component={lazy(() => import(`./events/event/add`))}
          moduleKey={MODULES.CALENDARS} // EVENTS MISSED
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/event/:id`}
          component={lazy(() => import(`./events/event/update`))}
          moduleKey={MODULES.CALENDARS} // EVENTS MISSED
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/training-program/list`}
          component={lazy(() => import(`./training-program/list`))}
          moduleKey={MODULES.TRAINING_PROGRAM}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/training-program/add`}
          component={lazy(() => import(`./training-program/add`))}
          moduleKey={MODULES.TRAINING_PROGRAM}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/training-program/:id`}
          component={lazy(() => import(`./training-program/update`))}
          moduleKey={MODULES.TRAINING_PROGRAM}
          permissionId={PERMISSIONS.EDIT}
        />
        {/* <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/page-builder/list`}
          component={lazy(() => import(`./page-builder/list`))}
          moduleKey={MODULES.PAGES}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/page-builder/add`}
          component={lazy(() => import(`./page-builder/add`))}
          moduleKey={MODULES.PAGES}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/page-builder/:id`}
          component={lazy(() => import(`./page-builder/update`))}
          moduleKey={MODULES.PAGES}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/menu-builder/list`}
          component={lazy(() => import(`./menu-builder/list`))}
          moduleKey={MODULES.MENUS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/menu-builder/add`}
          component={lazy(() => import(`./menu-builder/add`))}
          moduleKey={MODULES.MENUS}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/menu-builder/:id`}
          component={lazy(() => import(`./menu-builder/update`))}
          moduleKey={MODULES.MENUS}
          permissionId={PERMISSIONS.EDIT}
        /> */}
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/forms/request-data-form`}
          component={lazy(() => import(`./forms/request-data-form`))}
          moduleKey={MODULES.FORUMS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/forms/request-documentation-microfilm`}
          component={lazy(() =>
            import(`./forms/request-documentation-microfilm`)
          )}
          moduleKey={MODULES.FORUMS}
          permissionId={PERMISSIONS.SHOW}
        />
        <Route
          path={`${APP_PREFIX_PATH}/content/`}
          component={lazy(() => import(`./html-page`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/builder-content/`}
          component={lazy(() => import(`./html-page/html-page-builder`))}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/users/list`}
          component={lazy(() => import(`./users/list`))}
          moduleKey={MODULES.USERS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/users/add`}
          component={lazy(() => import(`./users/add`))}
          moduleKey={MODULES.USERS}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/users/:id`}
          component={lazy(() => import(`./users/update`))}
          moduleKey={MODULES.USERS}
          permissionId={PERMISSIONS.EDIT}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/admin-users/list`}
          component={lazy(() => import(`./admin-users/list`))}
          moduleKey={MODULES.USERS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/admin-users/add`}
          component={lazy(() => import(`./admin-users/add`))}
          moduleKey={MODULES.USERS}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/admin-users/:id`}
          component={lazy(() => import(`./admin-users/update`))}
          moduleKey={MODULES.USERS}
          permissionId={PERMISSIONS.EDIT}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/subscription-users/list`}
          component={lazy(() => import(`./subscription-users/list`))}
          moduleKey={MODULES.USERS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/subscription-users/add`}
          component={lazy(() => import(`./subscription-users/add`))}
          moduleKey={MODULES.USERS}
          permissionId={PERMISSIONS.ADD}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/end-users/list`}
          component={lazy(() => import(`./end-users/list`))}
          moduleKey={MODULES.USERS}
          permissionId={PERMISSIONS.SHOW}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/end-users/update/:id`}
          component={lazy(() => import(`./end-users/update`))}
          moduleKey={MODULES.USERS}
          permissionId={PERMISSIONS.EDIT}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/end-users/subscriptions/:id`}
          component={lazy(() => import(`./end-users/subscription-users`))}
          moduleKey={MODULES.USERS}
          permissionId={PERMISSIONS.EDIT}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/main-indicators/list`}
          component={lazy(() => import(`./main-indicators/list`))}
          moduleKey={MODULES.INDICATORS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/main-indicators/sort`}
          component={lazy(() =>
            import(`./indicators/components/order-indicators`)
          )}
          moduleKey={MODULES.INDICATORS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/main-indicators/add`}
          component={lazy(() => import(`./main-indicators/add`))}
          moduleKey={MODULES.INDICATORS}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/main-indicators/:id`}
          component={lazy(() => import(`./main-indicators/update`))}
          moduleKey={MODULES.INDICATORS}
          permissionId={PERMISSIONS.EDIT}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/sub-indicators/list`}
          component={lazy(() => import(`./indicators/list`))}
          moduleKey={MODULES.SELECTED_INDICATORS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/sub-indicators/add`}
          component={lazy(() => import(`./indicators/add`))}
          moduleKey={MODULES.FILTERS}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/sub-indicators/:id`}
          component={lazy(() => import(`./indicators/update`))}
          moduleKey={MODULES.FILTERS}
          permissionId={PERMISSIONS.EDIT}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/selected-indicators/list`}
          component={lazy(() => import(`./selected-indicators/list`))}
          moduleKey={MODULES.SELECTED_INDICATORS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/selected-indicators/add`}
          component={lazy(() => import(`./selected-indicators/add`))}
          moduleKey={MODULES.SELECTED_INDICATORS}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/selected-indicators/:id`}
          component={lazy(() => import(`./selected-indicators/update`))}
          moduleKey={MODULES.SELECTED_INDICATORS}
          permissionId={PERMISSIONS.EDIT}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/roles/list`}
          component={lazy(() => import(`./roles/list`))}
          moduleKey={MODULES.ROLES}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/services-tools/calendar`}
          component={lazy(() => import(`./calendar/calendar`))}
          moduleKey={MODULES.CALENDARS}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/services-tools/list`}
          component={lazy(() => import(`./service-tool/list`))}
          moduleKey={MODULES.SERVICES_TOOLS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/services-tools/add`}
          component={lazy(() => import(`./service-tool/add`))}
          moduleKey={MODULES.SERVICES_TOOLS}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/services-tools/:id`}
          component={lazy(() => import(`./service-tool/update`))}
          moduleKey={MODULES.SERVICES_TOOLS}
          permissionId={PERMISSIONS.EDIT}
        />
        <Route
          path={`${APP_PREFIX_PATH}/about-capmas/vision/:id`}
          component={lazy(() => import(`./about/vision-message/update`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/about-capmas/vision`}
          component={lazy(() => import(`./about/vision-message/list`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/about-capmas/main-measurments/add`}
          component={lazy(() => import(`./about/main-measurments/add`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/about-capmas/main-measurments/:id`}
          component={lazy(() => import(`./about/main-measurments/update`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/about-capmas/main-measurments`}
          component={lazy(() => import(`./about/main-measurments/list`))}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/about-capmas/head/add`}
          component={lazy(() => import(`./about/capmas-head/add`))}
          moduleKey={MODULES.CAPMAS_HEAD}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/about-capmas/head/:id`}
          component={lazy(() => import(`./about/capmas-head/update`))}
          moduleKey={MODULES.CAPMAS_HEAD}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/about-capmas/head`}
          component={lazy(() => import(`./about/capmas-head/list`))}
          moduleKey={MODULES.CAPMAS_HEAD}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/about-capmas/sector/add`}
          component={lazy(() => import(`./about/sectors/add`))}
          moduleKey={MODULES.SECTOR}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/about-capmas/sector/:id`}
          component={lazy(() => import(`./about/sectors/update`))}
          moduleKey={MODULES.SECTOR}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/about-capmas/sector`}
          component={lazy(() => import(`./about/sectors/list`))}
          moduleKey={MODULES.SECTOR}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/capmas-sectors/add`}
          component={lazy(() => import(`./capmas-sectors/add`))}
          moduleKey={MODULES.SECTOR}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/capmas-sectors/:id`}
          component={lazy(() => import(`./capmas-sectors/update`))}
          moduleKey={MODULES.SECTOR}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/capmas-sectors`}
          component={lazy(() => import(`./capmas-sectors/list`))}
          moduleKey={MODULES.SECTOR}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/about-capmas/history/add`}
          component={lazy(() => import(`./about/capmas-history/add`))}
          moduleKey={MODULES.CAPMAS_HISTORY}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/about-capmas/history/:id`}
          component={lazy(() => import(`./about/capmas-history/update`))}
          moduleKey={MODULES.CAPMAS_HISTORY}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/about-capmas/history`}
          component={lazy(() => import(`./about/capmas-history/list`))}
          moduleKey={MODULES.CAPMAS_HISTORY}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/about-capmas/law-regulation/add`}
          component={lazy(() => import(`./about/laws/add`))}
          moduleKey={MODULES.LAW_REGULATION}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/about-capmas/law-regulation/:id`}
          component={lazy(() => import(`./about/laws/update`))}
          moduleKey={MODULES.LAW_REGULATION}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/about-capmas/law-regulation`}
          component={lazy(() => import(`./about/laws/list`))}
          moduleKey={MODULES.LAW_REGULATION}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/about-capmas/terms-conditions/update`}
          component={lazy(() => import(`./about/terms-conditions/update`))}
          moduleKey={MODULES.USAGE_RIGHT_AND_TERMS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/about-capmas/terms-conditions`}
          component={lazy(() => import(`./about/terms-conditions/display`))}
          moduleKey={MODULES.USAGE_RIGHT_AND_TERMS}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/about-capmas/organization-structure`}
          component={lazy(() =>
            import(`./about/organization-structure/display`)
          )}
          moduleKey={MODULES.ORGANIZATION_HIERARCHY}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/magazine/update-description`}
          component={lazy(() =>
            import(
              `./egypt-statistical-magazine/components/magazine_description_component/update_magazine_description_component`
            )
          )}
          moduleKey={MODULES.EGYPT_STATISTICS_JOURNALS}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/magazine/list`}
          component={lazy(() => import(`./egypt-statistical-magazine/list`))}
          moduleKey={MODULES.EGYPT_STATISTICS_JOURNALS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/magazine/add`}
          component={lazy(() => import(`./egypt-statistical-magazine/add`))}
          moduleKey={MODULES.EGYPT_STATISTICS_JOURNALS}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/magazine/:id`}
          component={lazy(() => import(`./egypt-statistical-magazine/update`))}
          moduleKey={MODULES.EGYPT_STATISTICS_JOURNALS}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/home/news-tab-bar/list`}
          component={lazy(() => import(`./news-tab-bar/list`))}
          moduleKey={MODULES.NEWS_BAR}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/home/news-tab-bar/add`}
          component={lazy(() => import(`./news-tab-bar/add`))}
          moduleKey={MODULES.NEWS_BAR}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/home/news-tab-bar/:id`}
          component={lazy(() => import(`./news-tab-bar/update`))}
          moduleKey={MODULES.NEWS_BAR}
          permissionId={PERMISSIONS.EDIT}
        />
        <Route
          path={`${APP_PREFIX_PATH}/home/banner-details/list`}
          component={lazy(() => import(`./home-page-banner-details/list`))}
          moduleKey={MODULES.EGYPT_STATISTICS_JOURNALS}
          permissionId={PERMISSIONS.SHOW}
        />
        <Route
          path={`${APP_PREFIX_PATH}/home/banner-details/add`}
          component={lazy(() => import(`./home-page-banner-details/add`))}
          moduleKey={MODULES.EGYPT_STATISTICS_JOURNALS}
          permissionId={PERMISSIONS.ADD}
        />
        <Route
          path={`${APP_PREFIX_PATH}/home/banner-details/:id`}
          component={lazy(() => import(`./home-page-banner-details/update`))}
          moduleKey={MODULES.EGYPT_STATISTICS_JOURNALS}
          permissionId={PERMISSIONS.EDIT}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/data/main-topics/list`}
          component={lazy(() => import(`./main-topics/list`))}
          moduleKey={MODULES.SUBJECTS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/data/main-topics/add`}
          component={lazy(() => import(`./main-topics/add`))}
          moduleKey={MODULES.SUBJECTS}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/data/main-topics/:id`}
          component={lazy(() => import(`./main-topics/update`))}
          moduleKey={MODULES.SUBJECTS}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/international-day/list`}
          component={lazy(() => import(`./international-day/list`))}
          moduleKey={MODULES.EGYPT_STATISTICS_JOURNALS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/international-day/add`}
          component={lazy(() => import(`./international-day/add`))}
          moduleKey={MODULES.EGYPT_STATISTICS_JOURNALS}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/international-day/:id`}
          component={lazy(() => import(`./international-day/update`))}
          moduleKey={MODULES.EGYPT_STATISTICS_JOURNALS}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publications/list`}
          component={lazy(() => import(`./publications/list`))}
          moduleKey={MODULES.PUBLICATIONS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publications/add`}
          component={lazy(() => import(`./publications/add`))}
          moduleKey={MODULES.PUBLICATIONS}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publications/:id`}
          component={lazy(() => import(`./publications/update`))}
          moduleKey={MODULES.PUBLICATIONS}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publication-data/:id`}
          component={lazy(() => import(`./publication-data/list`))}
          moduleKey={MODULES.PUBLICATIONS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publication-data-update/:id`}
          component={lazy(() => import(`./publication-data/update`))}
          moduleKey={MODULES.PUBLICATIONS}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publications-type/list`}
          component={lazy(() => import(`./publications-type/list`))}
          moduleKey={MODULES.PUBLICATIONS_TYPE}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publications-type/add`}
          component={lazy(() => import(`./publications-type/add`))}
          moduleKey={MODULES.PUBLICATIONS_TYPE}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publications-type/:id`}
          component={lazy(() => import(`./publications-type/update`))}
          moduleKey={MODULES.PUBLICATIONS_TYPE}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/entering-publication-data`}
          component={lazy(() => import(`./entering-publication-data`))}
          moduleKey={MODULES.PUBLICATIONS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publications-versions/list`}
          component={lazy(() => import(`./publication-versions/list`))}
          moduleKey={MODULES.PUBLICATION_DETAILS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publications-versions/migrate`}
          component={lazy(() => import(`./publication-version-migrate`))}
          moduleKey={MODULES.PUBLICATION_DETAILS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publications-versions/add`}
          component={lazy(() => import(`./publication-versions/add`))}
          moduleKey={MODULES.PUBLICATION_DETAILS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publications-versions/:id`}
          component={lazy(() => import(`./publication-versions/update`))}
          moduleKey={MODULES.PUBLICATION_DETAILS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publications-infographic/add/:id`}
          component={lazy(() => import(`./publication-infographic/add`))}
          moduleKey={MODULES.INFOGRAPHIC}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publications-infographic/:id`}
          component={lazy(() => import(`./publication-infographic/list`))}
          moduleKey={MODULES.INFOGRAPHIC}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publications-details-files/add/:id`}
          component={lazy(() => import(`./publication-details-files/add`))}
          moduleKey={MODULES.PUBLICATION_DETAILS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publications-details/files/:id`}
          component={lazy(() => import(`./publication-details-files/list`))}
          moduleKey={MODULES.PUBLICATION_DETAILS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publications-evidenceAndClassification/add`}
          component={lazy(() =>
            import(`./publications-evidenceAndClassification/add`)
          )}
          moduleKey={MODULES.PUBLICATIONS_TYPE}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publications-evidenceAndClassification/list`}
          component={lazy(() =>
            import(`./publications-evidenceAndClassification/list`)
          )}
          moduleKey={MODULES.PUBLICATIONS_TYPE}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publications-evidenceAndClassification/:id`}
          component={lazy(() =>
            import(`./publications-evidenceAndClassification/update`)
          )}
          moduleKey={MODULES.PUBLICATIONS_TYPE}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/publications-subscriptions/list`}
          component={lazy(() => import(`./publications-subscriptions/list`))}
          moduleKey={MODULES.SUBSCRIPTION}
          permissionId={PERMISSIONS.SHOW}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/gates/add`}
          component={lazy(() => import(`./gates/add`))}
          moduleKey={MODULES.IMPORTANTPORTAL}
          permissionId={PERMISSIONS.SHOW}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/gates/list`}
          component={lazy(() => import(`./gates/list`))}
          moduleKey={MODULES.IMPORTANTPORTAL}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/gates/:id`}
          component={lazy(() => import(`./gates/update`))}
          moduleKey={MODULES.IMPORTANTPORTAL}
          permissionId={PERMISSIONS.SHOW}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/censuses/add`}
          component={lazy(() => import(`./censuses/add`))}
          moduleKey={MODULES.SURVEYCENSUSE}
          permissionId={PERMISSIONS.SHOW}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/censuses/list`}
          component={lazy(() => import(`./censuses/list`))}
          moduleKey={MODULES.SURVEYCENSUSE}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/censuses/:id`}
          component={lazy(() => import(`./censuses/update`))}
          moduleKey={MODULES.SURVEYCENSUSE}
          permissionId={PERMISSIONS.SHOW}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/happening-now/list`}
          component={lazy(() => import(`./happening-now/list`))}
          moduleKey={MODULES.HAPPENING_NOW}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/happening-now/add`}
          component={lazy(() => import(`./happening-now/add`))}
          moduleKey={MODULES.HAPPENING_NOW}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/happening-now/:id`}
          component={lazy(() => import(`./happening-now/update`))}
          moduleKey={MODULES.HAPPENING_NOW}
          permissionId={PERMISSIONS.EDIT}
        />

        <Route
          path={`${APP_PREFIX_PATH}/access-denied`}
          component={lazy(() => import(`./no-access-page/no-access-page`))}
        />

        {/* Data Quality & Validation */}
        <Route
          path={`${APP_PREFIX_PATH}/data-quality`}
          exact
          component={lazy(() => import(`./data-quality`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/data-quality/chart-data`}
          component={lazy(() => import(`./data-quality/chart-data`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/data-quality/anomalies`}
          component={lazy(() => import(`./data-quality/anomalies`))}
        />
        {/* <Route
          path={`${APP_PREFIX_PATH}/data-quality/validation`}
          component={lazy(() => import(`./data-quality/validation`))}
        /> */}
        {/* <Route
          path={`${APP_PREFIX_PATH}/data-quality/missing-values`}
          component={lazy(() => import(`./data-quality/missing-values`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/data-quality/subindicator`}
          component={lazy(() => import(`./data-quality/subindicator-view`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/data-quality/main-indicator`}
          component={lazy(() => import(`./data-quality/main-indicator-view`))}
        /> */}

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/departments/list`}
          component={lazy(() => import(`./departments/list/list-departments`))}
          moduleKey={MODULES.DEPARTMENTS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/departments/add`}
          component={lazy(() => import(`./departments/add/add-department`))}
          moduleKey={MODULES.DEPARTMENTS}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/departments/:id`}
          component={lazy(() =>
            import(`./departments/update/update-department`)
          )}
          moduleKey={MODULES.DEPARTMENTS}
          permissionId={PERMISSIONS.EDIT}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/population/list`}
          component={lazy(() => import(`./population/list`))}
          moduleKey={MODULES.PAGES}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/datarequest/add`}
          component={lazy(() => import(`./datarequest/add`))}
          moduleKey={MODULES.DATAREQUEST}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/datarequest/list`}
          component={lazy(() => import(`./datarequest/list`))}
          moduleKey={MODULES.DATAREQUEST}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/datarequest/:id`}
          component={lazy(() => import(`./datarequest/update`))}
          moduleKey={MODULES.DATAREQUEST}
          permissionId={PERMISSIONS.SHOW}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/microfilm/add`}
          component={lazy(() => import(`./microfilm/add`))}
          moduleKey={MODULES.MICROFILM}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/microfilm/list`}
          component={lazy(() => import(`./microfilm/list`))}
          moduleKey={MODULES.MICROFILM}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/microfilm/:id`}
          component={lazy(() => import(`./microfilm/update`))}
          moduleKey={MODULES.MICROFILM}
          permissionId={PERMISSIONS.EDIT}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/national-center/list`}
          component={lazy(() => import(`./national-center/list`))}
          moduleKey={MODULES.TRAINING_REQUEST}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/national-center/:id`}
          component={lazy(() => import(`./national-center/request-info`))}
          moduleKey={MODULES.TRAINING_REQUEST}
          permissionId={PERMISSIONS.SHOW}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/footer/selectedPages/add`}
          component={lazy(() => import(`./footer/selected-pages/add`))}
          moduleKey={MODULES.FOOTER}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/footer/selectedPages/list`}
          component={lazy(() => import(`./footer/selected-pages/list`))}
          moduleKey={MODULES.FOOTER}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/footer/selectedPages/:id`}
          component={lazy(() => import(`./footer/selected-pages/update`))}
          moduleKey={MODULES.FOOTER}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/footer/contactUs/:id`}
          component={lazy(() => import(`./footer/contact-us/update`))}
          moduleKey={MODULES.FOOTER}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/footer/contactUs`}
          component={lazy(() => import(`./footer/contact-us`))}
          moduleKey={MODULES.FOOTER}
          permissionId={PERMISSIONS.SHOW}
        />

        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/settings/general-settings`}
          component={lazy(() => import(`./Settings/settings`))}
          moduleKey={MODULES.SETTINGS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/email-templates/:id`}
          component={lazy(() =>
            import(`./Settings/email-templates/update-email-template`)
          )}
          moduleKey={MODULES.SETTINGS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/footer/social-links`}
          component={lazy(() => import(`./footer/footer-social-links`))}
          moduleKey={MODULES.FOOTER}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/survey/list`}
          component={lazy(() => import(`./survey/list`))}
          moduleKey={MODULES.SURVEY}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/survey/result/:id`}
          component={lazy(() => import(`./survey/components/survey-results`))}
          moduleKey={MODULES.SURVEY}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/survey/suggestions/:id`}
          component={lazy(() =>
            import(`./survey/components/survey-suggestions`)
          )}
          moduleKey={MODULES.SURVEY}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/survey/add`}
          component={lazy(() => import(`./survey/add`))}
          moduleKey={MODULES.SURVEY}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/survey/:id`}
          component={lazy(() => import(`./survey/update`))}
          moduleKey={MODULES.SURVEY}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/pinned-indicators/list`}
          component={lazy(() => import(`./pinned-indicators/list`))}
          moduleKey={MODULES.SURVEY}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/pinned-indicators/add`}
          component={lazy(() => import(`./pinned-indicators/add`))}
          moduleKey={MODULES.SURVEY}
          permissionId={PERMISSIONS.EDIT}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/measure-units/list`}
          component={lazy(() => import(`./measure-units/list`))}
          moduleKey={MODULES.MEASURE_UNITS}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/measure-units/add`}
          component={lazy(() => import(`./measure-units/add`))}
          moduleKey={MODULES.MEASURE_UNITS}
          permissionId={PERMISSIONS.ADD}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/measure-units/:id`}
          component={lazy(() => import(`./measure-units/update`))}
          moduleKey={MODULES.MEASURE_UNITS}
          permissionId={PERMISSIONS.EDIT}
        />
        {/* <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/form-builder/list`}
          component={lazy(() => import(`./form-builder/list`))}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/form-builder/add`}
          component={lazy(() => import(`./form-builder/add`))}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/form-builder/:id`}
          component={lazy(() => import(`./form-builder/update`))}
        /> */}
        {/* <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/languages/list`}
          component={lazy(() => import(`./Language/list`))}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/languages/add`}
          component={lazy(() => import(`./Language/add`))}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/languages/:id`}
          component={lazy(() => import(`./Language/update`))}
        /> */}

        {/* Chatbot */}

        {/* <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/chatbot/disliked-answers/list`}
          component={lazy(() => import(`./chatbot/disliked-answers/list`))}
          moduleKey={MODULES.CHATBOT}
          permissionId={PERMISSIONS.SHOW}
        /> */}
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/chatbot/conversations/list`}
          component={lazy(() => import(`./chatbot/conversations/list`))}
          moduleKey={MODULES.CHATBOT}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/chatbot/faqs/list`}
          component={lazy(() => import(`./chatbot/faqs/list`))}
          moduleKey={MODULES.CHATBOT}
          permissionId={PERMISSIONS.SHOW}
        />
        <ProtectedPermissionRoute
          path={`${APP_PREFIX_PATH}/chatbot/top-users/list`}
          component={lazy(() => import(`./chatbot/top-users/list`))}
          moduleKey={MODULES.CHATBOT}
          permissionId={PERMISSIONS.SHOW}
        />
        <Redirect
          from={`${APP_PREFIX_PATH}`}
          to={`${APP_PREFIX_PATH}/dashboard`}
        />
      </Switch>
    </Suspense>
  );
};

export default React.memo(AppViews);
